import { fromJS } from 'immutable';
import { createSelector } from 'reselect';

import * as utils from '../utils/duckHelpers';

export const types = {
    ...utils.requestTypes('UNCHECKED_ALERTS_COUNT'),
};

export const actions = {
     
    unchecked_alerts_countSet: (obj) => utils.action(types.UNCHECKED_ALERTS_COUNT_SET, obj),
};

const initialState = fromJS({
    loaded: 'loading',
});

export default (state = initialState, action) => {
    switch (action.type) {
    case types.UNCHECKED_ALERTS_COUNT_SET:
        if (action.payload.alerts_count) {
            return fromJS({
                uncheckedAlertsCount: action.payload.alerts_count,
                total: action.payload.total,
                loaded: 'complete',
            });
        }

        return fromJS({
            uncheckedAlertsCount: 0,
            loaded: 'empty',
        });

    case types.UNCHECKED_ALERTS_COUNT_RESET:
        return initialState;

    default:
        return state;
    }
};

const getUncheckedAlertsCount = (state) => state.get('app').get('uncheckedAlertsCount');

export const selectors = {
     
    getUncheckedAlertsCount: getUncheckedAlertsCount,
};
